import PropTypes from 'prop-types';
import { Icon } from '@iconify/react';
import searchFill from '@iconify/icons-eva/search-fill';
import trash2Fill from '@iconify/icons-eva/trash-2-fill';
import roundFilterList from '@iconify/icons-ic/round-filter-list';
// material
import { useTheme, experimentalStyled as styled } from '@material-ui/core/styles';
import { Box, Toolbar, Tooltip, IconButton, Typography, OutlinedInput, InputAdornment, Button } from '@material-ui/core';
import { sentenceCase } from 'change-case'
// ----------------------------------------------------------------------

const RootStyle = styled(Toolbar)(({ theme, noPadding }) => ({
  height: noPadding ? 0 : 96,
  display: 'flex',
  justifyContent: 'space-between',
  ...(noPadding && {
    padding: 0
  }),
  ...(!noPadding && {
    padding: theme.spacing(0, 1, 0, 3)
  }),
  '@media (min-width: 600px)': {
    height: noPadding ? 0 : 96,
    padding: noPadding ? 0 : theme.spacing(0, 1, 0, 3)
  }
}));

const SearchStyle = styled(OutlinedInput)(({ theme }) => ({
  width: 240,
  transition: theme.transitions.create(['box-shadow', 'width'], {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.shorter
  }),
  '&.Mui-focused': { width: 320, boxShadow: theme.customShadows.z8 },
  '& fieldset': {
    borderWidth: `1px !important`,
    borderColor: `${theme.palette.grey[500_32]} !important`
  }
}));

// ----------------------------------------------------------------------

CustomerOrderToolbar.propTypes = {
  numSelected: PropTypes.number,
  filterName: PropTypes.string,
  onFilterName: PropTypes.func,
  noPadding: PropTypes.bool
};

export default function CustomerOrderToolbar({ numSelected, filterName, onFilterName, item, noPadding }) {
  const theme = useTheme();
  const isLight = theme.palette.mode === 'light';
  const wordCount = filterName?.trim().split(/\s+/).filter(Boolean).length || 0;
  const isOverLimit = wordCount > 25;
  return (
    <RootStyle
     noPadding={noPadding}
      sx={{
        ...(numSelected > 0 && {
          color: isLight ? 'primary.main' : 'text.primary',
          bgcolor: isLight ? 'var(--signwise-app-chrome-toolbar)' : 'var(--signwise-app-chrome-toolbar)'
        })
      }}
    >
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <SearchStyle
        sx={{backgroundColor:'var(--signwise-app-chrome-toolbar)',
          ...(isOverLimit && {
            '& fieldset': {
              borderColor: theme.palette.error.main + ' !important'
            }
          })
        }}
          value={filterName}
          onChange={onFilterName}
          placeholder= {`Search ${sentenceCase(item)}...`}
          startAdornment={
            <InputAdornment position="start">
              <Box component={Icon} icon={searchFill} sx={{ color: 'text.disabled' }} />
            </InputAdornment>
          }
        />
         {isOverLimit && (
      <Typography variant="caption" color="error" sx={{ mt: 0.5 }}>
        Maximum 25 words allowed.
      </Typography>
    )}
  </Box>
      {numSelected > 0 && (
        <Typography component="div" variant="subtitle1">
          {numSelected} selected
        </Typography>
      )}
      {/* {numSelected > 0 ? (
        <Tooltip title="Delete">
          <IconButton>
            <Icon icon={trash2Fill} />
          </IconButton>
        </Tooltip>
      ) : (
        <Tooltip title="Filter list">
          <IconButton>
            <Icon icon={roundFilterList} />
          </IconButton>
        </Tooltip>
      )} */}
    </RootStyle>
  );
}
